
export default {
	isSidebarOpen: false,
    selectedModule: "ddd",
};
